import { Button } from "@mui/material";
import { ReactNode, useEffect, useState } from "react";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import PreviewIcon from '@mui/icons-material/Preview';
import SimpleDialog from "../../../common/SimpleDialog";
import AIReviewer from "./AIReviewer";

type Props = {
    initialDetails: string,
    contentType: 'SalesPitch',
    onAccept: (updatedText: string) => void
}

const AIReviewDialog = ({ initialDetails, onAccept, contentType }: Props) => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <Button variant="contained" size="small" fullWidth endIcon={<PreviewIcon />} onClick={() => setOpen(true)}>Smart Review</Button>

            <SimpleDialog open={open} onClose={() => setOpen(false)} sx={{ height: '100%' }}>
                <AIReviewer text={initialDetails} onClose={() => setOpen(false)} onAccept={onAccept} contentType={contentType} />
            </SimpleDialog>
        </>
    )
}

export default AIReviewDialog;